import { actionTypes } from '../constants/site';

const INITIAL_STATE = {
    loadingMsg: "",
    modal: null
}

const reducers = (state = INITIAL_STATE, action) => {
    switch (action.type) {
        
        case actionTypes.SET_LOADING_MSG:
            return { ...state, loadingMsg: action.payload.msg }
        case actionTypes.SET_MODAL:
            return { ...state, modal: action.payload.modal }
            case actionTypes.CLOSE_MODAL:
                return { ...state, modal: null }
        default:
            return state;
    }
}

export default reducers;